import React from 'react';
import { Menu } from 'antd';
import './TabsContainer.scss';
function TopNav({ onAction, menuConfig, currentMenu, ...props }) {
    const onMenuSelect = ({ key, keyPath }) => {
        if (typeof onAction === 'function') onAction(key);
    }
    return (<Menu mode="horizontal" activeKey={currentMenu ? currentMenu : menuConfig[0].key} style={{ paddingLeft: '10px', fontWeight: '500', fontSize: '16px' }}>{
        menuConfig && menuConfig?.map((menu) => {
            return (
                !menu?.children ? <Menu.Item key={menu?.key} icon={menu?.icon ? menu?.icon : false} onClick={(el) => onMenuSelect(el)}>
                    {menu.value}
                </Menu.Item> :
                    <Menu.SubMenu key={menu?.key} title={menu.value} icon={menu?.icon ? menu?.icon : false} onClick={(el) => onMenuSelect(el)}>
                        {
                            menu?.children?.map((eachSub) => {
                                return (<Menu.Item key={eachSub?.key} icon={eachSub?.icon ? eachSub?.icon : false}>
                                    {eachSub.value}
                                </Menu.Item>
                                )
                            })
                        }
                    </Menu.SubMenu>
            )
        })
    }
    </Menu>
    )

}

export default TopNav;